import { BaseEntity } from 'bookraw/shared/models/base-entity';
import { FileMedia } from 'bookraw/shared/models/media.model';

export enum TaxonomyType {
  TOPIC = 1,
  TAG = 2,
  GRAMMAR = 3,
  GAME = 4,
  GENRE = 5,
  LANGUAGE = 6,
  LEVEL = 8,
  TYPE = 9,
  SKILLSET = 10,
  ACCENT = 11,
  CEFR_LEVEL = 14,
  SPECIAL = 15,
  LEARNING_DIFFICULTY = 16,
  SERVICE = 18,
  FOCUS = 19,
  FOCUS_GRAMMAR = 20,
  FOCUS_VOCABULARY = 21,
  CENTURY_SKILL_21 = 22,
  CLIL_SUBJECTS = 23,
  FICTION = 24,
  FORM_MEANING = 25,
}

export class Taxonomy extends BaseEntity {
  name: string;
  title: string;
  alias: string;
  parent: Taxonomy | null;
}

export class TaxonomyTerm extends BaseEntity {
  taxonomyId: number;
  taxonomy: Taxonomy;
  name: string;
  title: string;
  alias: string;
  media: string;
  imageUrls: FileMedia;
}

export type TaxonomyTermsByType = { [key in TaxonomyType]?: TaxonomyTerm[] };
